import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Link } from '@mui/material';

import { useSelector } from '../../../redux/hooks';
import { selectUserProfile } from '../../../redux/actions/users';
import { getNotificationWarning } from '../formatWatchlist';

/** Warns when the user's notification settings stop watchlist emails. Never changes a setting. */
export default function NotificationWarning() {
    const userProfile = useSelector(selectUserProfile());
    const warning = userProfile ? getNotificationWarning(userProfile) : null;
    if (!warning) {
        return null;
    }
    return (
        <Alert severity="warning" sx={{ mb: 2 }}>
            {`${warning} `}
            <Link component={RouterLink} to="/user-profile">Ändra notisinställningar</Link>
        </Alert>
    );
}
